package pl.mothdigital.neuronowi

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.*
import com.varabyte.kobweb.silk.components.layout.*
import com.varabyte.kobweb.silk.style.*
import com.varabyte.kobweb.silk.style.common.*
import org.jetbrains.compose.web.css.*
import pl.mothdigital.neuronowi.common.utils.StructuredData

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    // Set document language for SEO and screen readers
    LaunchedEffect(Unit) {
        kotlinx.browser.document.documentElement?.setAttribute("lang", "pl")

        // Add schema.org JSON-LD structured data for SEO
        val script = kotlinx.browser.document.createElement("script").apply {
            setAttribute("type", "application/ld+json")
            textContent = StructuredData.getOrganizationJsonLd()
        }
        kotlinx.browser.document.head?.appendChild(script)
    }

    SilkApp {
        Surface(
            modifier = SmoothColorStyle.toModifier().minHeight(100.vh),
        ) {
            Box(contentAlignment = Alignment.Center) {
                content()
            }
        }
    }
}
